export default __webpack_public_path__ + "static/media/fountain.06e6dd34.png";